import React, { useEffect, useRef } from 'react'
import { AccountInfo } from '@azure/msal-browser'

import { Redirect } from 'react-router-dom'
import useComponentVisible from '../../hooks/useComponentVisible'
export interface IBookmarkProps {
  title: string
  activeAccount?: AccountInfo
}

const BookmarkMyAccount = (props: IBookmarkProps) => {
  const { ref2, isBookmarkVisible } = useComponentVisible(true)
  const mountedRef = useRef(false)
  const ospBaseUrl = process.env.REACT_APP_REDIRECT_URI
  const registrationUrl = process.env.REACT_APP_AZURE_B2C_REGISTRATION_URL
  //const loginUrl = process.env.REACT_APP_B2C_LOGIN_URL
  const query = new URLSearchParams()
  query.append('System', 'Web')
  query.append('Title', props.title)
  query.append('SourceUrl', window.location.href)
  const url = ospBaseUrl + '/BookmarkToMyAccount?' + query.toString()

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current && props.activeAccount) {
      window.location.href = url
    }
    return () => {
      mountedRef.current = false
    }
  }, [])

  if (props.activeAccount) {
    return <Redirect to={url} />
  } else {
    return (
      <div ref={ref2}>
        {isBookmarkVisible && (
          <div
            aria-hidden="true"
            className="dropdown save-to-my-account-dropdown"
          >
            <span className="h4">
              <b>Register to save these settings for next time</b>
            </span>
            <div className="dropdown-body inline">
              <div className="dropdown-body-inner">
                <span className="h6">Why register?</span>
                <ul>
                  <li>Get priority support!</li>
                  <li>
                    Save results from our Pay, Shift, Leave and Notice and
                    Redundancy Calculators
                  </li>
                  <li>Bookmark your favourite pages</li>
                  <li>Ask us questions and save our replies</li>
                  <li>View tailored information relevant to you.</li>
                </ul>
                <a className="button is-primary" href={registrationUrl}>
                  Register
                </a>
              </div>

              <div className="dropdown-body-inner has-padded-left-border">
                <span className="h6">Already have an account?</span>

                <p>Log in now to save this page to your account.</p>
                <a className="button is-primary" href={url}>
                  Log-in
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}
export default BookmarkMyAccount
